import { Pipe, PipeTransform } from '@angular/core';
import { ContentService } from '../services/content.service';

@Pipe({
  name: 'componentContainerStyle'
})
export class ComponentContainerStylePipe implements PipeTransform {
  constructor(private contentService: ContentService) {}
  transform(
    component: unknown,
    playMotionPath?: any,
    componentData?: string,
    playMotionPathData?: string,
  ): any[] {
    let componentWrapStyles = this.contentService.getComponentContainerStyle(component, playMotionPath)
    return componentWrapStyles;
  }
}
